define('plugin/bonus/BonusPlugin',['require','lib/plugin/PluginAbstract','plugin/bonus/controller/BonusController','handlebars','lib/AppRouter'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var BonusController = require('plugin/bonus/controller/BonusController');

    var Handlebars = require('handlebars');
    var AppRouter = require('lib/AppRouter');

    return PluginAbstract.extend({

        _paymentSystemCollection: null,
        _controller: null,
        _recurringProfileController: null,
        _requestModel: null,
        _step: null,

        initialize: function () {
            //this._paymentSystemCollection = new PaymentSystemCollection();

            this._clientModel = this.getOption('clientModel');

            this._controller = new BonusController({
                'clientModel': this._clientModel,
                'app': this.getOption('app')
            });

            var bonusRouter = new AppRouter({
                appRoutes: {
                    'bonus(/page/:page)(/)': 'info',
                    'bonus/info(/page/:page)(/)': 'info',
                    'bonus/view/:id(/)': 'view',
                    'bonus/pay/:id(/return/:return)(/)': 'pay',
                },
                menuItem: 'bonus_system',
                controller: this._controller
            });

            PluginAbstract.prototype.initialize.apply(this);

            this.initTemplateHelpers();
        },

        initTemplateHelpers: function () {

        },

    });

});
